import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CommentDataPayload,
  ICommentsDetailModel,
  ICommentsDetailModelV2
} from '../../../pricing-simulator/components/comment-box-container/comment-box-container.model';
import fetchCommentsForRow, { fetchCommentsForRowV2 } from './api/drawer-api';

const getDataForComments = createAsyncThunk(
  'getDataForComments',
  async ({
    commentData,
    scenarioId
  }: {
    commentData: CommentDataPayload;
    scenarioId: number;
  }) => {
    const response = await fetchCommentsForRow(commentData, scenarioId);
    return response;
  }
);

const getDataForCommentsV2 = createAsyncThunk(
  'getDataForCommentsV2',
  async ({
    commentData,
    scenarioId,
    sourceId
  }: {
    commentData: CommentDataPayload;
    scenarioId: number;
    sourceId: number;
  }) => {
    const response = await fetchCommentsForRowV2(
      commentData,
      scenarioId,
      sourceId
    );
    return response;
  }
);

interface IDrawerState {
  fetchingComments: boolean;
  isDisplayComments: boolean;
  /* model type: IProductComments */
  commentsData: ICommentsDetailModelV2;
  selectedRow: any;
}

const initialState: IDrawerState = {
  fetchingComments: false,
  isDisplayComments: false,
  commentsData: {
    details: {
      name: '',
      icon: ''
    },
    comments_data: {}
  },
  selectedRow: {}
};

const DrawerManagerSlice = createSlice({
  name: 'Drawer-manager',
  initialState,
  reducers: {
    handleVisibilityOfComments(
      state,
      action: PayloadAction<{
        rowDetails: any;
      }>
    ) {
      state.isDisplayComments = true;
      state.selectedRow = action.payload.rowDetails;
    },
    handleCloseEventOfDrawer(state) {
      state.isDisplayComments = false;
      state.selectedRow = {};
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getDataForCommentsV2.pending, (state) => {
        state.fetchingComments = true;
      })
      .addCase(getDataForCommentsV2.fulfilled, (state, action) => {
        state.fetchingComments = false;
        state.commentsData = action.payload;
      })
      .addCase(getDataForCommentsV2.rejected, (state) => {
        state.fetchingComments = false;
        state.commentsData = {
          details: {
            name: '',
            icon: ''
          },
          comments_data: {}
        };
      })
});

export const { handleVisibilityOfComments, handleCloseEventOfDrawer } =
  DrawerManagerSlice.actions;

export { getDataForComments, getDataForCommentsV2 };

export default DrawerManagerSlice;
